export default __webpack_public_path__ + "static/media/logo.1924b7b3.svg";